<template>
  <div class="content">
    <div class="top">
      <div class="msg">基本信息</div>
      <div
        class="details"
        v-show='this.getSourceType == 1 ||this.getSourceType == 2'
      >
        <div>企业名称: <span>{{companyName}}</span> </div>
        <div>统一代码: <span>{{unified}}</span> </div>
        <div>姓名: <span>{{Name}}</span> </div>
        <div>电话: <span>{{phone}}</span> </div>
      </div>
      <div
        class="details1"
        v-show='this.getSourceType == 3 ||this.getSourceType == 4'
      >
        <!-- <div>企业名称: <span>{{companyName}}</span> </div> -->
        <!-- <div>统一代码: <span>{{unified}}</span> </div> -->
        <div>姓名: <span>{{Name}}</span> </div>
        <!-- <div>法人姓名: <span>{{personL}}</span> </div> -->
        <div style="margin-top:10px;">电话: <span>{{phone}}</span> </div>
      </div>
      <!-- <el-descriptions title="用户信息">
        <el-descriptions-item label="企业名称">{{companyName}}
        </el-descriptions-item>
        <el-descriptions-item label="统一代码">{{unified}}</el-descriptions-item>
        <el-descriptions-item label="姓名">{{Name}}</el-descriptions-item>
        <el-descriptions-item label="法人姓名">{{personL}} </el-descriptions-item>
        <el-descriptions-item label="电话">{{phone}} </el-descriptions-item>
      </el-descriptions> -->
    </div>
  </div>
</template>
<script>
import {queryUserInfoByToken} from '@/api/myCenter'

export default {
  data () {
    return {
      companyName: '',
      unified: '',
      Name: '',
      personL: '',
      phone: ''
    }
  },
  computed: {
    getUser: function () {
      return JSON.parse(sessionStorage.getItem("user"))
    },
    getSourceType: function () {
      return sessionStorage.getItem("sourceType")
    }
  },
  created () {
    queryUserInfoByToken().then(res => {
      res = this.paramDecrypt(res);
      if (res.code == 200) {
        this.companyName = res.data.enterpriseName?res.data.enterpriseName:'-'
        this.unified = res.data.organization?res.data.organization:'-'
        this.Name = res.data.name?res.data.name:'-'
        this.phone = res.data.mobilePhone?res.data.mobilePhone:'-'  
      }
    })
  },
  methods: {
  }
}
</script>
<style lang='less' scoped>
.content {
  width: 100%;
  min-height: 863px;
  border-radius: 8px;
  box-sizing: border-box;
  .top {
    box-sizing: border-box;
    margin-left: 20px;
    width: 95%;
    min-height: 300px;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.2);
    padding-top: 20px;
    .msg {
      display: flex;
      height: 34px;
      font-size: 24px;
      font-family: Alibaba PuHuiTi;
      font-weight: 500;
      color: #2981ee;
      border-left: 8px solid #2981ee;
      text-align: center;
      padding-left: 30px;
    }
    .details {
      margin: 20px 80px;
      height: 200px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      div {
        font-family: Alibaba PuHuiTi;
        font-weight: 600;
        color: #252525;
        span {
          font-size: 15px;
          font-family: Alibaba PuHuiTi;
          font-weight: 400;
          color: #252525;
        }
      }
    }
    .details1 {
      margin: 20px 80px;
      height: 200px;
      display: flex;
      flex-direction: column;
      div {
        font-family: Alibaba PuHuiTi;
        font-weight: 600;
        color: #252525;
        span {
          font-size: 15px;
          font-family: Alibaba PuHuiTi;
          font-weight: 400;
          color: #252525;
        }
      }
    }
  }
}
</style> 